// src/components/juliette/AddToCalendarButton.tsx
// Bouton "Ajouter a mon agenda" affiche sous une reponse de Juliette quand elle
// propose un evenement (marqueur [ADDCAL:url] -> cf src/lib/juliette-addcal.ts).
// Ouvre le lien Google Calendar "render" : l'agent valide en 1 clic (on n'ecrit
// jamais directement dans son agenda).
import { CalendarPlus } from "lucide-react";

export function AddToCalendarButton({ url }: { url: string }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="mt-1.5 inline-flex items-center gap-1.5 rounded-full bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground shadow-sm transition-opacity hover:opacity-90"
    >
      <CalendarPlus className="h-3.5 w-3.5" />
      Ajouter à mon agenda
    </a>
  );
}
